module.exports = __webpack_public_path__ + "static/media/next-icon-sake-cup-o.d9dd3c40.svg";